import { render, staticRenderFns } from "./SearchFabric.vue?vue&type=template&id=0c1b4f9c&scoped=true&"
import script from "./SearchFabric.vue?vue&type=script&lang=js&"
export * from "./SearchFabric.vue?vue&type=script&lang=js&"
import style0 from "./SearchFabric.vue?vue&type=style&index=0&id=0c1b4f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b4f9c",
  null
  
)

export default component.exports